export const CHECKIN_NOT_READY = 1
export const CHECKIN_READY = 2
export const CHECKIN_PASSED = 3
